"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _clientErrorLogger = _interopRequireDefault(require("../../../util/clientErrorLogger"));

var _ApiGetter = _interopRequireDefault(require("../ApiGetter"));

var _moment = _interopRequireDefault(require("moment"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var SessionModel = (_class = /*#__PURE__*/function () {
  function SessionModel(props) {
    _classCallCheck(this, SessionModel);

    _initializerDefineProperty(this, "inactivityTimeRemaining", _descriptor, this);

    _initializerDefineProperty(this, "serverTimeRemaining", _descriptor2, this);

    _initializerDefineProperty(this, "user", _descriptor3, this);

    _initializerDefineProperty(this, "isLoggedIn", _descriptor4, this);

    _initializerDefineProperty(this, "currentUtc", _descriptor5, this);

    _initializerDefineProperty(this, "flashMessage", _descriptor6, this);

    _initializerDefineProperty(this, "isImpersonating", _descriptor7, this);

    _initializerDefineProperty(this, "userAccounts", _descriptor8, this);

    _initializerDefineProperty(this, "modifiedBy", _descriptor9, this);

    _initializerDefineProperty(this, "features", _descriptor10, this);

    _initializerDefineProperty(this, "unreadNotificationCount", _descriptor11, this);

    _initializerDefineProperty(this, "notificationCount", _descriptor12, this);

    _initializerDefineProperty(this, "siteFooterItems", _descriptor13, this);

    _initializerDefineProperty(this, "featureToggles", _descriptor14, this);

    _initializerDefineProperty(this, "requestInfoUrl", _descriptor15, this);

    if (!props) {
      // not having session props is okay because we can load them async
      return;
    }

    this.markAcknowledgedUrl = "api/session/mark-acknowledged";
    this.markAllAcknowledgedUrl = "api/session/mark-all-acknowledged";
    this.update(props);
    this.inactivityTimeRemaining = this.maxInactivitySeconds;
  }

  _createClass(SessionModel, [{
    key: "tick",
    value: function tick(dispatcher) {
      this.inactivityTimeRemaining -= 1;
      this.serverTimeRemaining -= 1;
      this.checkServerExpiration(dispatcher);
      this.checkInactivity(dispatcher);
    }
  }, {
    key: "restart",
    value: function restart(dispatcher) {
      this.inactivityTimeRemaining = this.maxInactivitySeconds;

      if (this.serverTimeRemaining < this.inactivityTimeRemaining) {
        dispatcher.emit("LOAD_SESSION_DATA", {
          forceRefresh: true
        });
      }
    }
  }, {
    key: "update",
    value: function update(props) {
      this.user = props.user;
      this.loginPath = props.loginPath;
      this.isLoggedIn = props.isLoggedIn;
      this.serverTimeRemaining = props.serverTimeRemaining;
      this.maxInactivitySeconds = props.inactivityThreshold ? props.inactivityThreshold : 600;
      this.warningThreshold = props.expirationWarningSeconds ? props.expirationWarningSeconds : 60;
      this.environmentName = props.environmentName;
      this.currentUtc = props.currentUtc;
      this.timeWarp = _moment.default.duration(props.timeWarp);
      this.flashMessage = props.flashMessage;
      this.isImpersonating = props.isImpersonating;
      this.userAccounts = props.userAccounts;
      this.modifiedBy = props.modifiedBy;
      this.features = props.features;
      this.unreadNotificationCount = props.unreadNotificationCount;
      this.notificationCount = props.notificationCount;
      this.baseAddress = props.baseAddress;
      this.siteFooterModel = props.siteFooterModel;
      this.featureToggles = props.featureToggles;
      this.requestInfoUrl = props.requestInfoUrl;
    }
  }, {
    key: "loadFromServer",
    value: function loadFromServer(dispatcher, forceRefresh, retryDelay) {
      var apiGetter = new _ApiGetter.default(dispatcher, {
        disableLoadSpinner: true
      });
      var self = this;

      if (!this.user || forceRefresh) {
        // If you make any changes to this at all, be sure to test various registration flows (slug, access page, etc)
        apiGetter.fetch("/api/session", function (res) {
          // Don't ever delete the user from the session, since some portal-specific code assumes that it will always be there.
          if (!res.user) {
            res.user = self.user;
          } // update this model with new data


          self.update(res);

          if (res.isLoggedIn) {
            self.start(dispatcher, forceRefresh);
          }
        }, function () {
          // There's not really a good reason for this to fail, so maybe it's a connection error? Try to reload it a few more times.
          retryDelay = (retryDelay || 0) + 5000;

          if (retryDelay <= 15000) {
            // Abandon after three attempts.
            setTimeout(function () {
              self.loadFromServer(dispatcher, forceRefresh, retryDelay);
            }, retryDelay);
          } else {
            _clientErrorLogger.default.notify("Could not load session data", "warning");
          }
        });
      } else if (this.isLoggedIn) {
        this.start(dispatcher, false);
      }
    }
  }, {
    key: "start",
    value: function start(dispatcher, forceRefresh) {
      if (!this.serverTimeRemaining) {
        // if there is no server time defined, don't start the timer on the client
        // this is used on the intranet to prevent the timer
        return;
      }

      if (!this.started) {
        var tickInterval = 1000;
        this.timer = setInterval(this.tick.bind(this, dispatcher), tickInterval);
        this.bindActivityEvents(dispatcher);
        this.started = true;
      }

      this.restart(dispatcher);
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.timer);
    }
  }, {
    key: "addListenerMulti",
    value: function addListenerMulti(el, eventNames, fn) {
      var events = eventNames.split(" ");

      for (var i = 0, iLen = events.length; i < iLen; i++) {
        if (el.addEventListener) {
          el.addEventListener(events[i], fn, true);
        } else {
          el.attachEvent("on" + events[i], fn);
        }
      }
    }
  }, {
    key: "bindActivityEvents",
    value: function bindActivityEvents(dispatcher) {
      var bindingEl = window ? window : document;

      if (bindingEl) {
        this.addListenerMulti(bindingEl, "touchstart touchmove touchend keydown keyup click", this.restart.bind(this, dispatcher));
      }
    } // checks the server-side session tick in seconds

  }, {
    key: "checkServerExpiration",
    value: function checkServerExpiration(dispatcher) {
      var secsLeft = this.serverTimeRemaining;

      if (secsLeft <= 0) {
        dispatcher.emit("SESSION_EXPIRED");
        this.stop();
      } else if (secsLeft < this.warningThreshold && secsLeft < this.inactivityTimeRemaining) {
        // send a request to extend server-side session
        dispatcher.emit("LOAD_SESSION_DATA", {
          forceRefresh: true
        });
      }
    } // check on the client inactivity counter

  }, {
    key: "checkInactivity",
    value: function checkInactivity(dispatcher) {
      if (this.inactivityTimeRemaining <= 0) {
        dispatcher.emit("SESSION_EXPIRED");
        this.stop();
      } else if (this.inactivityTimeRemaining <= this.warningThreshold) {
        dispatcher.emit("SESSION_EXPIRING", {
          remainingTime: this.inactivityTimeRemaining
        });
      } else {
        dispatcher.emit("HIDE_SESSION_EXPIRING_MODAL");
      }
    }
  }, {
    key: "getLoginPath",
    value: function getLoginPath() {
      return this.loginPath;
    }
  }, {
    key: "isStarted",
    value: function isStarted() {
      return this.started;
    }
  }, {
    key: "getCurrentUtcNow",
    value: function getCurrentUtcNow() {
      return (0, _moment.default)().add(this.timeWarp);
    }
  }]);

  return SessionModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "inactivityTimeRemaining", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "serverTimeRemaining", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isLoggedIn", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentUtc", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "flashMessage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isImpersonating", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "userAccounts", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "modifiedBy", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "features", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "unreadNotificationCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "notificationCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "siteFooterItems", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "featureToggles", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "requestInfoUrl", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "tick", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "tick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restart", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "restart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadFromServer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadFromServer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "start", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "start"), _class.prototype)), _class);
var _default = SessionModel;
exports.default = _default;